import { createVueApp } from "@saflib/vue";
import { setClientName } from "@saflib/links";
import App from "./AdminApp.vue";
import { router } from "./router.ts";
import { admin_strings } from "./strings.ts";
import {
  vuetifyConfig,
  sentryCallback,
  initClientObservability,
  powerUpMfaRequiredHref,
} from "@vendata/power-up-clients-common";
import "vuetify/styles";

export const main = () => {
  setClientName("admin");
  initClientObservability();
  createVueApp(App, {
    router,
    vuetifyConfig,
    callback: sentryCallback,
    i18nMessages: {
      ...admin_strings,
    },
    mfaRequiredHref: powerUpMfaRequiredHref(),
  });
};
